export default {
  header: 'Predefiniowane repozytorium',
};
